module.exports = __webpack_public_path__ + "img/uml-diagram.083c88d5.png";